import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';
import { NewDeliveryMethodSfMapStore, CreateDeliveryMethodSfMapDto } from 'stores/configuration/sf-mappings/delivery-method-sf-map-store';
import { nameof } from 'utils/object';
import { ItemReference } from 'stores/dataStore';
import DeliveryMethodEditor from 'widgets/bussiness/delivery-method-editor';

interface NewDeliveryMethodMapViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newDeliveryMethodMapStore?: NewDeliveryMethodSfMapStore;
}

// tslint:disable-next-line:no-empty-interface
interface NewDeliveryMethodMapViewState {
  userClickedSave: boolean;
  deliveryMethod: ItemReference;
}

@connect(['newDeliveryMethodMapStore', NewDeliveryMethodSfMapStore])
class NewDeliveryMethodMapView extends React.Component<NewDeliveryMethodMapViewProps, NewDeliveryMethodMapViewState> {
  private get newDeliveryMethodMapStore() {
    return this.props.newDeliveryMethodMapStore;
  }

  constructor(props: NewDeliveryMethodMapViewProps) {
    super(props);
    this.state = {
      userClickedSave: false,
      deliveryMethod: null
    };
    this.newDeliveryMethodMapStore.createNew({
      deliveryTypeId: null,
      mappingToSF: ''
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewDeliveryMethodMapViewProps) {
    if (this.newDeliveryMethodMapStore.state.result && this.newDeliveryMethodMapStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.setState({ userClickedSave: true });
    this.newDeliveryMethodMapStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newDeliveryMethodMapStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    this.setState({ userClickedSave: false });
    const change = {};
    change[property] = value;
    this.newDeliveryMethodMapStore.change({ ...this.newDeliveryMethodMapStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newDeliveryMethodMapStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Delivery Method Map')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.newDeliveryMethodMapStore.state.result && !this.newDeliveryMethodMapStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newDeliveryMethodMapStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newDeliveryMethodMapStore.state.item && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Field required error={!this.state.deliveryMethod && this.state.userClickedSave}>
                    <div className={`required field`}>
                      <label>{t('Delivery Method Map')}</label>
                      <DeliveryMethodEditor
                        nullable
                        value={this.state.deliveryMethod}
                        placeholder={t('Delivery Method Map')}
                        onChange={c => {
                          this.newDeliveryMethodMapStore.state.item.deliveryTypeId = c ? c.id : null;
                          this.setState({ deliveryMethod: c, userClickedSave: false });
                        }}
                      />
                    </div>
                  </Form.Field>
                  <Form.Input
                    required
                    fluid
                    error={!this.newDeliveryMethodMapStore.state.item.mappingToSF && this.state.userClickedSave}
                    label={t('Mapping To SF')}
                    placeholder={t('Mapping To SF')}
                    value={this.newDeliveryMethodMapStore.state.item.mappingToSF}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateDeliveryMethodSfMapDto>('mappingToSF'), value)}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewDeliveryMethodMapView);
